import React from "react";
import { Dropdown, Menu } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import routes from "routes";
import * as icons from "Assets/Icons";
import { OfferTypeNames } from "values";

const TypesMenu = (
    <Menu className={"rmxo-dropdown-menu"}>
        <Menu.Item
            className={"rmxo-dropdown-menu-item"}
            onClick={() => window.location.assign(`${window.rmxo_indexPage}/${routes.flats}`)}
        >
            <img src={icons.iconFlats} alt={"Byty"} className={"rmxo-index-icon"} />
            Byty
        </Menu.Item>
        <Menu.Item
            className={"rmxo-dropdown-menu-item"}
            onClick={() => window.location.assign(`${window.rmxo_indexPage}/${routes.houses}`)}
        >
            <img src={icons.iconHouses} alt={"Domy a vily"} className={"rmxo-index-icon"} />
            Domy a vily
        </Menu.Item>
        <Menu.Item
            className={"rmxo-dropdown-menu-item"}
            onClick={() => window.location.assign(`${window.rmxo_indexPage}/${routes.lands}`)}
        >
            <img src={icons.iconLands} alt={"Pozemky"} className={"rmxo-index-icon"} />
            Pozemky
        </Menu.Item>
        <Menu.Item
            className={"rmxo-dropdown-menu-item"}
            onClick={() => window.location.assign(`${window.rmxo_indexPage}/${routes.commercial}`)}
        >
            <img src={icons.iconCommercial} alt={"Komerční nemovitosti"} className={"rmxo-index-icon"} />
            Komerční nemovitosti
        </Menu.Item>
        <Menu.Item
            className={"rmxo-dropdown-menu-item"}
            onClick={() => window.location.assign(`${window.rmxo_indexPage}/${routes.other}`)}
        >
            <img src={icons.iconOther} alt={"Ostatní nemovitosti"} className={"rmxo-index-icon"} />
            Ostatní
        </Menu.Item>
    </Menu>
);

export default function TypesDropdown({ selectedLabel }: { selectedLabel: OfferTypeNames }): JSX.Element {
    return (
        <Dropdown overlay={TypesMenu} trigger={["click"]}>
            <button className="rmxo-dropdown">
                {selectedLabel} <CaretDownOutlined className={"rmxo-dropdown-icon"} />
            </button>
        </Dropdown>
    );
}
